var map = {
	"./act": 1505,
	"./act.ts": 1505,
	"./gmat": 1506,
	"./gmat.ts": 1506,
	"./gre": 1507,
	"./gre.ts": 1507,
	"./ielts": 1508,
	"./ielts.ts": 1508,
	"./ielts_general_training": 1509,
	"./ielts_general_training.ts": 1509,
	"./lsat": 1510,
	"./lsat.ts": 1510,
	"./mcat": 1511,
	"./mcat.ts": 1511,
	"./sat": 1512,
	"./sat.ts": 1512,
	"./toefl": 1513,
	"./toefl.ts": 1513
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2516;
module.exports = webpackAsyncContext;